import { HttpClientModule } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { MyService } from './providers/myService';
import { PusherServiceProvider } from './providers/myService';
import { UserData } from './providers/user-data';
import { NotificationsPopover } from './pages/notifications-popover/notifications-popover';
import { NotificationService } from './providers/notification.service';
export function initializeApp(userData: UserData) {
  return () => userData.checkExternalSession();
}

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false
    })
  ],
  declarations: [AppComponent, NotificationsPopover],
  entryComponents: [NotificationsPopover],
  providers: [
    InAppBrowser,
    SplashScreen,
    StatusBar,
    MyService,
    PusherServiceProvider,
    NotificationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [UserData],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
